
const _ = require('lodash');

const PromiseQueue = require('promise-queue');

module.exports = class SinglePromiseQueue extends PromiseQueue {
	push (...args) {
		const ret = super.push(...args);
		const last = _.last(this._queue);
		this._queue = [ last ];
		return ret;
	}
};

